"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = filterTree;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function filterTree(tree, childrenProp) {
  var predicate = arguments.length <= 2 || arguments[2] === undefined ? function () {
    return true;
  } : arguments[2];
  var comparison = arguments.length <= 3 || arguments[3] === undefined ? function (a, b, ai, bi) {
    return ai - bi;
  } : arguments[3];

  function filterTreeWithOptions(tree) {
    return tree && tree.filter(predicate).map(function (node, index) {
      if (!node[childrenProp]) {
        return { payload: node, index: index };
      }
      return {
        payload: _extends({}, node, _defineProperty({}, childrenProp, filterTreeWithOptions(node[childrenProp]))),
        index: index
      };
    }).sort(function (a, b) {
      return comparison(a.payload, b.payload, a.index, b.index);
    }).map(function (obj) {
      return obj.payload;
    });
  }

  return filterTreeWithOptions(tree);
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-classifications-hierarchy/build/filterTree.js
 ** module id = 447
 ** module chunks = 0
 **/